<template>
    <div data-testid="booked-session" class="course-container info-course-button text-start p-4 mb-2" :class="[isActive ?  'selected' : '']">{{sessionName}}, {{dayFormat}} at {{startTimeFormat}} - {{endTimeFormat}}</div>
</template>

<script setup>
import { format } from 'date-fns';
import { parse } from 'date-fns';
import { ref, computed, watch, defineProps } from "vue";

const props = defineProps({
    selected: String,
    startDate: String,
    startTime: String,
    endTime: String,
    sessionName: String,
    infoSessionId: Number
})

const selected = ref(props.selected)
const isActive = ref(false)

let dayFormat = computed(() => {
    return format(new Date(props.startDate), 'EEEE do LLLL yyyy')
})
let startTimeFormat = computed(() => {
    return format(parse(props.startTime, 'HH:mm', new Date()), 'h:mm a')
})
let endTimeFormat = computed(() => {
    return format(parse(props.endTime, 'HH:mm', new Date()), 'h:mm a')
})

watch(selected, () => {
    isActive.value = selected === props.infoSessionId;
})
</script>

<style scoped>
.info-course-button {
    font-weight: 500;
    width:100%;
    box-shadow: 4px 5px 22px 7px rgba(158,158,158,0.21);
    text-decoration: none;
    color: #007ab3;
    background: white;
}

.course-container {
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    background-color: rgb(240 240 240);
    position: relative;
    display: inline-flex;
    width: 78%;
    height: 100%;
    border-bottom: 4px solid #0000;
    border-color: #1e1964;
    color: rgb(50, 50, 50);
}

.info-course-button:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

</style>

